import { Dispatch, SetStateAction } from 'react'

import { EmploymentNotification } from '@builddocs/data-management'
import { List, Stack, Typography } from '@mui/material'
import { RefetchOptions, RefetchQueryFilters } from 'react-query'

import EmploymentItem from '../../molecules/EmploymentItem'

import { EmploymentListSkeleton } from './EmploymentListSkeleton'

interface OwnProps {
  employments: EmploymentNotification[]
  setUnreadCount: Dispatch<SetStateAction<number>>
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => void
  isLoading: boolean
}

type EmploymentListProps = OwnProps

export const EmploymentList = ({
  employments,
  setUnreadCount,
  refetch,
  isLoading,
}: EmploymentListProps) => {
  return (
    <List
      dense
      disablePadding
      sx={{
        maxHeight: '80vh',
        overflow: 'auto',
        '& li:hover + li hr:first-of-type, & li:focus + li hr:first-of-type': {
          opacity: 0,
        },
      }}
    >
      {!isLoading ? (
        employments.length > 0 ? (
          employments.map((employment, index) => (
            <EmploymentItem
              key={employment.businessKey}
              employment={employment}
              last={index + 1 === employments.length}
              refetch={refetch}
              setUnreadCount={setUnreadCount}
            />
          ))
        ) : (
          <Stack alignItems="center" sx={{ py: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>Нет уведомлений</Typography>
          </Stack>
        )
      ) : (
        <EmploymentListSkeleton />
      )}
    </List>
  )
}
